import { supabase } from '@/integrations/supabase/client';
import { CONSENT_KEY } from '@/lib/consent';

export interface EditorialSource { kind: 'guide' | 'room'; slug: string; at: number }
const KEY = 'loftloom_editorial_source';
export const ATTRIBUTION_TTL = 30 * 60 * 1000;
export function measurementAllowed() {
  try { return localStorage.getItem(CONSENT_KEY) === 'accepted' && !(navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl; }
  catch { return false; }
}
export function validEditorialSource(value: unknown, now = Date.now()): value is EditorialSource {
  if (!value || typeof value !== 'object') return false;
  const s = value as EditorialSource;
  return (s.kind === 'guide' || s.kind === 'room') && typeof s.slug === 'string' && /^[a-z0-9][a-z0-9-]{0,159}$/.test(s.slug) && Number.isFinite(s.at) && s.at <= now && now - s.at < ATTRIBUTION_TTL;
}
export function rememberEditorialSource(kind: EditorialSource['kind'], slug: string) {
  if (!measurementAllowed()) return;
  try { sessionStorage.setItem(KEY, JSON.stringify({ kind, slug, at: Date.now() })); } catch { /* unavailable */ }
}
export function getEditorialSource(): EditorialSource | undefined {
  try {
    if (!measurementAllowed()) { sessionStorage.removeItem(KEY); return; }
    const value: unknown = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (validEditorialSource(value)) return value;
    sessionStorage.removeItem(KEY);
  } catch { /* malformed or unavailable storage */ }
}
// First-party report storage is separate from the built-in visitor event pipeline.
export function saveEditorialOutcome(event: 'product_view' | 'cart_add', source: EditorialSource, product: string, quantity = 1) {
  if (!measurementAllowed()) return;
  void supabase.functions.invoke('editorial-performance', { body: { id: crypto.randomUUID(), sourceKind: source.kind, sourceSlug: source.slug, event, product, quantity } }).catch(() => undefined);
}